<template>
  <div class="transcription-skeleton--popup">
    <div class="d-flex justify-content-center">
      <div class="premium-feature-badge">
        <b-img src="@img/icons-premium-star.svg" />
        <span class="ml-1 font-weight-bold">PREMIUM FEATURE</span>
      </div>
    </div>
    <h2 class="text-center my-3">VIDEO TRANSCRIPTION</h2>
    <p class="text-center">
      Automatically transcribe speech from your video for closed captioning, interactive time stamps, and video
      search!
    </p>
    <button type="button" @click="upgrade()" class="btn upgrade-btn" data-testid="upgrade-to-unlock-transcription">
      Contact Us to Unlock
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import track from "@/src/tracking.js";

export default {
  computed: {
    ...mapState(['currentOrganization', 'user'])
  },
  methods: {
    upgrade: function() {
      const properties = {
        plan_code: this.currentOrganization?.attributes?.plan_code,
        plan_name: this.currentOrganization?.attributes?.plan_name,
        user_id: this.user?.id
      };
      track('transcription_feature_request', properties);
      window.open("https://www.getcloudapp.com/contact/", "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "application.scss";

.transcription-skeleton--popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  border-radius: 16px;
  box-shadow: inset 0 0 0 0.8px rgba(255, 255, 255, 0.27), 0 0 0 0.5px rgba(0, 0, 0, 0.11),
    0 2px 9px 1.8px rgba(0, 0, 0, 0.17);
  background-color: $white;
}

.premium-feature-badge {
  padding: 0.3rem;
  display: flex;
  align-items: center;
  border-radius: 24px;
  background-color: #f7f9fc;
  color: #fd6f69;
  font-size: 0.75rem;
}

h4,
p {
  color: $dark-gray;
}

.upgrade-btn {
  width: 100%;
  height: 3rem;
  border-radius: 5px;
  background-color: #fe8952;
  color: var(--white);
  font-weight: bold;
}
</style>
